var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center pb-4"},[_c('v-icon',{attrs:{"large":"","left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('span',{staticClass:"subtitle-1 font-weight-bold"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }